module.exports = __webpack_public_path__ + "static/window-treatments-02d8d4c3e30f1b1522d80a5b5364f740.jpg";